import { Empiricus } from "./whitelabels/Empiricus";
import { Genial } from "./whitelabels/Genial";
import { SpiderCrypto } from "./whitelabels/SpiderCrypto";
import { SpiderTrader } from "./whitelabels/SpiderTrader";
import { Underblock } from "./whitelabels/Underblock";
const typeClient = process.env.REACT_APP_CLIENT || "SpiderTrader";

type ColorTuple = [
  string,
  string?,
  string?,
  string?,
  string?,
  string?,
  string?,
  string?,
  string?,
  string?
];

type ColorCategories =
  | "primary"
  | "primaryOpacity"
  | "complementary"
  | "complementaryOpacity"
  | "basic"
  | "other"
  | "alerts"
  | "alertsOpacity";

interface IPropsLinkItem {
  name: string;
  path: string;
  blank?: boolean;
}

type ISocialLinks = {
  name: string;
  path: string;
  icon: string;
};

interface Ilanguages {
  pt_br: string;
  en_us: string;
  es: string;
}
interface IContacts {
  name: string;
  contact: string;
  contactText?: string;
  description?: string;
}
export interface ILinkItem extends IPropsLinkItem {
  subLinks?: IPropsLinkItem[];
}

interface IFooterLink {
  name: string;
  path: Ilanguages;
}

export interface IClient {
  colors: Record<ColorCategories, ColorTuple>;
  image: Record<"logo" | "icon" | "icon2" | "logo2", string>;
  name: string;
  title?: string;
  favicon?: string;
  description?: string;
  acceptLanguage: string[];
  redirect: string;
  autoRegister: boolean;
  terms: Ilanguages;
  privacyPolicy: Ilanguages;
  address?: {
    street: string;
    number: string;
    complement: string;
    neighborhood?: string;
    city: string;
    state: string;
    country: string;
    zipcode: string;
  };
  contacts?: IContacts[];
  email?: {
    email: string;
    link: string;
  };
  footerLinksTerms?: IFooterLink[];
  footerLinks?: IFooterLink[];
  navbarLinksDefault: ILinkItem[];
  navbarLinksClient: ILinkItem[];
  navbarLinksAnalyst: ILinkItem[];
  socialLinks: ISocialLinks[];
  hasBrokers: boolean;
  hasCancelButton: boolean;
  hasClarity: boolean;
  hasFinancial: boolean;
}

const client_data: Record<string, IClient> = {
  SpiderTrader: SpiderTrader,
  Genial: Genial,
  Empiricus: Empiricus,
  SpiderCrypto: SpiderCrypto,
  Underblock: Underblock,
};

export const client_selected = client_data[typeClient];
